module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "x-SECTION-BREAK"
  }), _vm._v(" "), _c('p', {
    staticClass: "x2FM-RM-TTL",
    attrs: {
      "id": "toc_marker-1"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toc_marker-2"
    }
  }, [_c('p', {
    staticClass: "x2TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#toc_marker-2"
    }
  }, [_vm._v("The Daughter of Belgium, by Marci Jefferson")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toc_marker-3"
    }
  }, [_c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#toc_marker-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Record Set Right, by Lauren Willig")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toc_marker-4"
    }
  }, [_c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#toc_marker-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All for the Love of You, by Jennifer Robson")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toc_marker-5"
    }
  }, [_c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#toc_marker-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("After You’ve Gone, by Evangeline Holland")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toc_marker-6"
    }
  }, [_c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#toc_marker-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Something Worth Landing For, by Jessica Brockmole")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toc_marker-7"
    }
  }, [_c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#toc_marker-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hour of the Bells, by Heather Webb")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toc_marker-8"
    }
  }, [_c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#toc_marker-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An American Airman in Paris, by Beatriz Williams")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toc_marker-9"
    }
  }, [_c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#toc_marker-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Photograph, by Kate Kerrigan")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toc_marker-10"
    }
  }, [_c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter9#toc_marker-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hush, by Hazel Gaynor")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toc_marker-11"
    }
  }, [_c('p', {
    staticClass: "x2TOC-AFTER-TXB1"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_c('span', {
    attrs: {
      "href": "#/AbouttheAuthor#toc_marker-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toc_marker-12"
    }
  }, [_c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_c('span', {
    attrs: {
      "href": "#/Credits#toc_marker-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Credits")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toc_marker-13"
    }
  }, [_c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_c('span', {
    attrs: {
      "href": "#/Copyright#toc_marker-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toc_marker-14"
    }
  }, [_c('p', {
    staticClass: "x2TOC"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_c('span', {
    attrs: {
      "href": "#/AboutthePublisher#toc_marker-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 63
// module chunks = 0